import { render, staticRenderFns } from "./ModalItemsHes.vue?vue&type=template&id=6bb2cc34"
import script from "./ModalItemsHes.vue?vue&type=script&lang=js"
export * from "./ModalItemsHes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports